const ArrowRight = (props) => (
  <svg viewBox="0 0 15 25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.105 13.596L0 25h2.86L15 12.5 2.86 0H0l11.105 11.404z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)

export default ArrowRight
